import ClosableMessage from './ClosableMessage';
export default ClosableMessage;
